<script>
  import moment from 'moment';
  export let recentOperations = [];
  export let addOperation = () => {};
  export let deleteOperation = () => {};

  let newOperation = null;
</script>

<div class="col" style="height: 375px; overflow: scroll;">
  <div class="text-center">
    <label for="newOperation" class="form-label">Yapılan Son İşlemler</label>
    <input
      type="text"
      class="form-control text-center"
      id="newOperation"
      placeholder="Yeni İşlem Ekle"
      bind:value={newOperation}
    />
    <button
      on:click|preventDefault={addOperation(newOperation)}
      class="btn btn-success mt-2 mb-3">Ekle</button
    >
  </div>
  {#each recentOperations as operation}
    <div class="row justify-content-center align-items-center mb-3">
      <div class="col-md-3">
        <input
          type="date"
          max={moment(new Date()).format('YYYY-MM-DD')}
          class="form-control"
          bind:value={operation.date}
        />
      </div>
      <div class="col-md-8">
        <textarea
          type="text"
          class="form-control"
          style="resize: none;"
          bind:value={operation.note}
        />
      </div>
      <div class="col-md-1 mt-2">
        <button
          on:click|preventDefault={deleteOperation(operation._id)}
          class="btn btn-danger">Sil</button
        >
      </div>
    </div>
  {/each}
</div>
